/* eslint-disable */
import particles from './vue-particles.vue'

const VueParticles = {

    install (Vue, options) {
        Vue.component('vue-particles', particles)
    }

}

export default VueParticles
/* eslint-disable */



//////////////////
// WEBPACK FOOTER
// ./~/vue-particles/src/vue-particles/index.js
// module id = 323
// module chunks = 20